module.exports = __webpack_public_path__ + "img/Duque.80d79993.jpg";